
angular.module 'app'

  .filter 'ceil', -> (input) ->
    Math.ceil(input or 0)
